module.exports = __webpack_public_path__ + "assets/icons/contextmenu.svg?f45964";


//////////////////
// WEBPACK FOOTER
// ../xod-client/src/core/assets/icons/contextmenu.svg
// module id = 948
// module chunks = 0